import { styled } from "@mui/material/styles";
import { Box, Typography } from "@mui/material";
import { semantic, ramps, hexToRGBA } from "../../../common/theme/brandTokens";

export const CardRoot = styled(Box)<{ bordercolor: string; status?: string }>(({ bordercolor, status }) => {
  let backgroundColor = "transparent";

  if (status === "warning") {
    backgroundColor = hexToRGBA(semantic.warning.main, 0.2);
  } else if (status === "critical") {
    backgroundColor = hexToRGBA(semantic.error.main, 0.2);
  }
  
  return {
    borderLeft: `6px solid ${bordercolor}`,
    paddingLeft: 8,
    minWidth: 0,
    width: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    gap: 2,
    backgroundColor,
    paddingTop: 4,
    paddingBottom: 4,
    paddingRight: 8,
    position: "relative",
  };
});

export const CardLabel = styled(Typography, { shouldForwardProp: (p) => p !== "vitalcolor" })<{ vitalcolor?: string }>(({ theme, vitalcolor }) => ({
  fontSize: 10,
  fontWeight: 600,
  color: vitalcolor ?? theme.palette.text.secondary,
  textTransform: "uppercase",
  letterSpacing: "0.05em",
  opacity: 0.75,
  lineHeight: 1.2,
}));

export const ValueRow = styled(Typography, { shouldForwardProp: (p) => p !== "vitalcolor" })<{ vitalcolor?: string }>(({ theme, vitalcolor }) => ({
  fontSize: 25,
  fontWeight: 700,
  lineHeight: 1.1,
  color: vitalcolor ?? theme.palette.text.primary,
  whiteSpace: "nowrap",
}));

export const ValueUnit = styled("span")({
  fontSize: 12,
  fontWeight: 400,
  marginLeft: 3,
});

export const ForecastRow = styled(Box)({
  display: "flex",
  alignItems: "center",
  gap: 3,
});

export const StatusIcon = styled(Box, { shouldForwardProp: (p) => p !== "statuscolor" })<{ statuscolor?: string }>(({ statuscolor }) => ({
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  paddingLeft: 4,
  paddingRight: 4,
  paddingTop: 2,
  paddingBottom: 2,
  borderRadius: 4,
  backgroundColor: statuscolor ?? semantic.warning.main,
  color: ramps.neutral[0],
  fontSize: 10,
  fontWeight: 600,
  marginTop: 2,
  gap: 2,
}));
